<template>
  <div class="item-wrapper">
    <div class="key">{{ item.name }}</div>
    <div class="value">{{ item.value }}</div>
  </div>
</template>
<script setup lang="ts">
defineProps(["item"]);
</script>
<style lang="scss" scoped>
.item-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
</style>
